/**
 * File init.js.
 * Initializes any JS files that require jQuery at the top level of /js, under a single document ready function
 */

let initCount = 0;
function init() {
  // wait for jQuery to load
  if (typeof jQuery == 'undefined') {
    // limit retries to 5s
    if (initCount < 100) {
      initCount++;
      setTimeout(init, 50);
    }
    return;
  }

  // DOM content has loaded
  jQuery(function ($) {
    emailCaptureInit($);
    heroInit($);
    lpFilledTrackInit($);
    navMenuInit($);
    qspInit($);
    responsiveTable($);
    sourceTrackInit($);
    if (typeof promoInit === 'function') promoInit($);
    updateDisclaimerIcons();
  });

  // all files have loaded
  jQuery(window).on('load', () => {
    assignSlickSlideAriaLabel();
  });
}

init();